export const trimStr = (text, maxLength = 40) => {
  if (!text) return "";

  try {
    text = decodeURIComponent(text);
  } catch {}

  text = text
    .replace(/[\r\n\u2028\u2029]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (/\.[a-z0-9]{2,5}$/i.test(text)) {
    const nameWithoutExt = text.replace(/\.[^/.]+$/, "");
    return nameWithoutExt.length > maxLength
      ? nameWithoutExt.substring(0, maxLength) + "..."
      : nameWithoutExt;
  }

  if (text.includes(".") && text.length < 300 && text.includes("/")) {
    try {
      const url = new URL(text.includes("http") ? text : `https://${text}`);
      const formatted = url.hostname.replace(/^www\./, "") + url.pathname;
      return formatted.length > maxLength
        ? formatted.substring(0, maxLength) + "..."
        : formatted;
    } catch {}
  }

  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};
